import {useEffect} from "react";
import moment from "moment";
import {Button, ListGroup, Placeholder} from "react-bootstrap";
import {Link, useParams} from "react-router-dom";

import Util from "@/lib/Util.jsx";
import {dateConfigs} from "@/assets/resources.js";
import {useHistoryData} from "@/hooks/use-history-data.jsx";

import Alert from "@/components/ui/alert/alert.jsx";
import Title from "@/components/ui/title/title.jsx";
import bcAll from "@/components/breadcrumb-app/breadcrumb-context.jsx";
import FeedbackError from "@/components/ui/feedback-error/feedback-error.jsx";
import AnimatedComponents from "@/components/ui/animated-component/animated-components.jsx";

const useBreadcrumb = bcAll.useBreadcrumb;

moment.locale(dateConfigs.lang);

export default function DeparturePoints() {
  const {id} = useParams();
  
  const departureTimeDate = id;
  const departureTimeDateIsValid = departureTimeDate.match(/^(\d+)X(\d+)X(\d+)$/) || false;
  
  const {setLabel} = useBreadcrumb();
  const {error, loaded, data, lineData} = useHistoryData(Util.checkIsValid(id) ? id : null, null);
  
  useEffect(() => {
    document.title = "Mobilidade - Histórico de Pontos de Parada";
    
    setLabel("history", "Histórico");
    setLabel("departure-points", "Pontos de Parada");
    
    if (lineData?.[0]) {
      const lineLabel = (`${lineData[0]["line_number"] || "Linha"} - ` + (lineData[0]["line_name"] ? lineData[0]["line_name"] : ""))?.replaceAll("/", " ⇄ ");
      setLabel(id, lineLabel);
    }
  }, [lineData, departureTimeDate, departureTimeDateIsValid, id]);
  
  if (!Util.checkIsValid(id)) return <Alert variant={'danger'} margin={"mt-0"}>O id da linha não foi informado.</Alert>
  
  if (loaded) return (
    <AnimatedComponents>
      <Placeholder as="h1" animation="glow"><Placeholder xs={6}/></Placeholder>
      <Placeholder as="h2" animation="glow"><Placeholder xs={4}/></Placeholder>
    </AnimatedComponents>
  )
  else if (error) {
    console.error(error);
    return <FeedbackError code={error.response ? error.response.status || 500 : 500} text={error.message} type={'card'}/>;
  } else if (data.length === 0) return <Alert variant={'danger'} margin={"mt-0"}>Histórico não localizado.</Alert>;
  
  return (
    <AnimatedComponents>
      <h1 className={"m-0 p-0"}><span className={"text-body-secondary"}>Histórico de Pontos de Parada</span></h1>
      <Link to={`/lines/${id}`} className={"text-decoration-none"}>
        <Title type={"h2"} classX=" fs-3 d-inline mt-1 p-0 d-block mb-0">
          <span className="d-block" style={{fontSize: "inherit"}}>Linha {(lineData?.[0]?.["line_number"] + " - " + lineData?.[0]?.["departure_location"] + " ⇄ " + lineData?.[0]?.["destination_location"] || "")?.replaceAll("/", " ⇄ ")}</span>
        </Title>
      </Link>
      
      <section className={"d-flex flex-column gap-4 gap-sm-5 mt-5 align-items-start"}>
        <AnimatedComponents>
          <ListGroup>
            <ListGroup.Item as={Link} className={"cursor-pointer"} to={`/lines/${id}#paradas`}>
              <span className={"d-block text-primary"}>{Util.renderText(Util.safeParseDate(lineData?.[0]?.["datetime_last_modify"]).format("DD/MM/YYYY"))}</span>
              <span className={"text-body-tertiary"}>Pontos atualizados em {Util.renderText(Util.safeParseDate(lineData?.[0]?.["datetime_last_modify"]).format("DD/MM/YYYY"))}</span>
            </ListGroup.Item>
          </ListGroup>
        </AnimatedComponents>
      </section>
      
      <Link to={`/lines/${id}`} className={"d-inline-flex mt-3 text-decoration-none"}>
        <Button variant={"primary"}>Veja todas as informações da linha {lineData?.[0]?.["line_number"] ?? ""}</Button>
      </Link>
    </AnimatedComponents>
  );
}
